import { Box, Button, Flex, HStack, Heading, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, SimpleGrid, Skeleton, Spacer, Text, useDisclosure } from '@chakra-ui/react';
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import { InputControl, SwitchControl } from 'formik-chakra-ui';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Formik, Form } from 'formik';
import moment from 'moment/moment';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import Axios from 'axios';

// Icons
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { TbEdit } from "react-icons/tb";
import { Icon5G, IconArrowRight } from "../../Assets/GENERALES/Icons";

// Components
import AdminNavbar from '../../Components/Navbar/AdminNavbar';
import { getData, postData } from '../../Services/api';

// Imagen
import Movil from '../../Assets/EQUIPOS/movil.webp';

// Styles
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/skyblue';
import '../Public/style.css';

const EquipoSchema = Yup.object().shape({
    equipo_principal: Yup.boolean(),
    equipo_nombre: Yup.string()
        .when("equipo_principal", {
            is: false,
            then: () => Yup.string()
                .required('Campo requerido'),
        }),
    equipo_descuento: Yup.string()
        .when("equipo_principal", {
            is: false,
            then: () => Yup.string()
                .required('Campo requerido'),
        }),
    equipo_precio_normal: Yup.string()
        .when("equipo_principal", {
            is: false,
            then: () => Yup.string()
                .required('Campo requerido'),
        }),
    equipo_referencia: Yup.string()
        .when("equipo_principal", {
            is: false,
            then: () => Yup.string()
                .required('Campo requerido'),
        }),
    equipo_precio_oferta: Yup.string()
        .when("equipo_principal", {
            is: false,
            then: () => Yup.string()
                .required('Campo requerido'),
        }),
    equipo_numero_cuotas: Yup.string()
        .when("equipo_principal", {
            is: false,
            then: () => Yup.string()
                .required('Campo requerido'),
        }),
    equipo_valor_cuotas: Yup.string()
        .when("equipo_principal", {
            is: false,
            then: () => Yup.string()
                .required('Campo requerido'),
        }),
});

const AdminEquipos = () => {

    const [initialValues, setInitialValues] = useState({equipo_nombre: '', equipo_referencia: '', equipo_descuento: '', equipo_precio_normal: '0', equipo_precio_oferta: '0', equipo_numero_cuotas: '', equipo_valor_cuotas: '0', equipo_principal: false});
    const [previewImage, setPreviewImage] = useState('https://via.placeholder.com/150');
    const [referenciaEquipo, setReferenciaEquipo] = useState('Referencia');
    const [nombreEquipo, setNombreEquipo] = useState('Nombre del equipo');
    const [updateButton, setUpdateButton] = useState(false);
    const [targetEquipos, setTargetEquipos] = useState([]);
    const [precioNormal, setPrecioNormal] = useState('0');
    const [precioOferta, setPrecioOferta] = useState('0');
    const [numeroCuotas, setNumeroCuotas] = useState('0');
    const [typeAction, setTypeAction] = useState('CREAR');
    const [valorCuotas, setValorCuotas] = useState('0');
    const [localImage, setLocalImage] = useState(false);
    const [updatePage, setUpdatePage] = useState(false);
    const [principal, setPrincipal] = useState(false);
    const [descuento, setDescuento] = useState('0');
    const [idEquipo, setIdEquipo] = useState(null);
    const [file, setFile] = useState(null);

    const { isOpen, onOpen, onClose } = useDisclosure();

    const navigate = useNavigate();

    const infoUser = localStorage.getItem('infoUser');

    useEffect(() => {
        if (JSON.parse(infoUser)?.rol === 'Disenador') {
            const extractEquipos = async() => {
                const consultData = await getData('view-all');
                if (consultData?.data?.OK == true) {
                    setTargetEquipos(consultData?.data?.DATA);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: `Ocurrio un error!`
                    });
                }
            };

            extractEquipos();
        } else {
            navigate(-1);
        }
    }, [updatePage]);

    const handleChange = (e) => {
        const archivo = e.target.files[0];
        setFile(archivo);
        if (archivo) {
            const lector = new FileReader();
            lector.onloadend = () => {
                setPreviewImage(lector.result);
            };
            lector.readAsDataURL(archivo);
            setLocalImage(true);
        } else {
            setPreviewImage(null);
        }
    };

    const handleUpdateTypeOffer = () => {
        setInitialValues({equipo_nombre: '',equipo_referencia: '',equipo_descuento: '',equipo_precio_normal: '0',equipo_precio_oferta: '0',equipo_numero_cuotas: '',equipo_valor_cuotas: '0', equipo_principal: true,equipo_descripcion: ''});
        setPreviewImage('https://via.placeholder.com/150');
        setPrincipal(!principal);
        setPrecioNormal('0');
        setPrecioOferta('0');
        setValorCuotas('0');
        setDescuento('0');
        setFile([]);
    };

    const formatNumber = (number) => {
        const parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.join(",");
    };

    const handleAddEquipo = async({equipo_nombre,equipo_referencia,equipo_descuento,equipo_precio_normal,equipo_precio_oferta,equipo_numero_cuotas,equipo_valor_cuotas,equipo_principal,equipo_descripcion}) => {
        const Toast = Swal.mixin({
            toast: true,
            showConfirmButton: false,
            position: 'bottom-end',
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        });

        setUpdateButton(true);

        const url = typeAction === 'CREAR' ? 'upload-image' : `update-equipo/${idEquipo}`;

        var formData = new FormData();

        formData.append('equipo_nombre', equipo_nombre);
        formData.append('equipo_referencia', equipo_referencia);
        formData.append('equipo_descuento', equipo_descuento);
        formData.append('equipo_precio_normal', equipo_precio_normal);
        formData.append('equipo_precio_oferta', equipo_precio_oferta);
        formData.append('equipo_numero_cuotas', equipo_numero_cuotas);
        formData.append('equipo_valor_cuotas', equipo_valor_cuotas);
        formData.append('equipo_descripcion', equipo_descripcion);
        formData.append('equipo_principal', equipo_principal ? 1 : 0);
        formData.append('equipo_fecha', moment().format('YYYY-MM-DD HH:mm:ss'));
        typeAction === 'CREAR' && formData.append('equipo_estado', 1);
        file && formData.append('equipo_imagen', file)

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            }
        };

        const addEquipo =  await Axios.post(`https://webserver.becallcolombia.com/backend_entel/public/api/${url}`, formData, config);

        if (addEquipo?.data?.OK === true) {
            setUpdatePage(!updatePage);
            Toast.fire({
                icon: 'success',
                title: addEquipo?.data?.MESSAGERESPONSE
            })
        } else {
            Toast.fire({
                icon: 'error',
                title: addEquipo?.data?.MESSAGERESPONSE
            })
        }

        setUpdateButton(false);
        onClose();
    };

    const handleUpdateEquipo = async(id, estado) => {
        const Toast = Swal.mixin({
            toast: true,
            showConfirmButton: false,
            position: 'bottom-end',
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        });

        const update = await postData(`update-equipo/${id}`, {equipo_estado: estado === 1 ? 0 : 1});

        if (update?.OK === true) {
            setUpdatePage(!updatePage);
            Toast.fire({
                icon: 'success',
                title: update?.MESSAGERESPONSE
            })
        } else {
            Toast.fire({
                icon: 'error',
                title: update?.MESSAGERESPONSE
            })
        }
    };

    const editEquipo = (values) => {
        setIdEquipo(values.equipo_id);
        setTypeAction('EDITAR');
        setInitialValues({
            equipo_nombre: values?.equipo_nombre,
            equipo_referencia: values?.equipo_referencia,
            equipo_descuento: values?.equipo_descuento,
            equipo_precio_normal: values?.equipo_precio_normal,
            equipo_precio_oferta: values?.equipo_precio_oferta,
            equipo_numero_cuotas: values?.equipo_numero_cuotas,
            equipo_valor_cuotas: values?.equipo_valor_cuotas,
            equipo_principal: values.equipo_principal === 0 ? false : true,
            equipo_descripcion: values?.equipo_descripcion
        });
        setReferenciaEquipo(values?.equipo_referencia);
        setPrecioNormal(values?.equipo_precio_normal);
        setPrecioOferta(values?.equipo_precio_oferta);
        setNumeroCuotas(values?.equipo_numero_cuotas);
        setValorCuotas(values?.equipo_valor_cuotas);
        setDescuento(values?.equipo_descuento);
        setNombreEquipo(values?.equipo_nombre);
        setPrincipal(values.equipo_principal === 0 ? false : true);
        setPreviewImage(values.equipo_imagen);
        setLocalImage(false);
        onOpen();
    };

    return (
        <>
            {/* Navbar */}
            <AdminNavbar /> 

            {/* Cuerpo del elemento */}
            <Box  w='90%' mx='auto' my='10'>
                {/* Button create */}
                <Flex>
                    <Spacer />
                    <Button leftIcon={<AiOutlineAppstoreAdd />} onClick={() => {setTypeAction('CREAR'), onOpen()}} bg="#FD3D00" color='white' className='Subtitle' _hover={{border: '2px solid #FD3D00', color: '#FD3D00', bg: 'white'}} fontWeight="bold">
                        Crear equipo
                    </Button>
                </Flex>

                {/* Tarjetas de equipos */}
                <Box mx="auto" w={['90%','90%','90%','85%','85%']} mt={['10','10','5','5','5']}>
                    <Splide
                        hasTrack={false}
                        options={{
                            perPage: 4,
                            perMove: 1,
                            pagination: true,
                            autoplay: false,
                            gap: '50px',
                            breakpoints: {
                                1250: {
                                    perPage: 3,
                                },
                                840: {
                                    perPage: 2,
                                },
                                600: {
                                    perPage: 1,
                                }
                            },
                        }}
                    >
                        <SplideTrack>
                            {
                                targetEquipos.length > 0
                                ?
                                targetEquipos.map((equipos, i) => (
                                    equipos.equipo_principal === 0
                                        ?
                                            <SplideSlide key={equipos.equipo_id}>
                                                <Box>
                                                    <Flex flexDirection={['row', 'row','column','column','column']} border='1px solid #E9E9E9' borderTopRadius='12px' _hover={{border:'1px solid #002EFF'}} h='100%'>
                                                        <Flex bg='#F7F7F7' p='16px' justifyContent='center' alignItems='center' borderLeftRadius={['12px','12px','0px','0px','0px']} borderTopRadius={['0px','0px','12px','12px','12px']} position='relative'>
                                                            <Box position='absolute' top='2' right='2' left={[2,2,'auto','auto','auto']}>
                                                                <Icon5G size='35' />
                                                            </Box>
                                                            <Flex w={['110px','110px','272px','272px','272px']} h={['220px','220px','226px','226px','226px']} justifyContent='center' alignItems='center'>
                                                                <Image src={`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${equipos.equipo_imagen}`} w='auto' h='auto' />
                                                            </Flex>
                                                        </Flex>
                                                        <Box px='3' py='4'>
                                                            <Text className="Title">
                                                                {equipos.equipo_nombre}
                                                            </Text>
                                                            <Text className="Subtitle" fontSize='lg' h='85px' noOfLines='2'>  
                                                                {equipos.equipo_referencia}
                                                            </Text>
                                                            
                                                            <Button cursor='default' px='2' py='1' fontSize='15px' borderRadius='4px' _focusVisible={{}} _hover={{}} bg='#A0F3D9' className="Title" size='xs' _active={{}} h='auto'>
                                                                {equipos.equipo_descuento}% dcto.
                                                            </Button>
                                                            
                                                            <HStack spacing='1' mt='1'>
                                                                <Text color='#66686C' className="Subtitle" fontSize='sm' my='1'> 
                                                                    Precio normal:
                                                                </Text>
                                                                <Text className='Subtitle' as='s'>${formatNumber(equipos.equipo_precio_normal)}</Text>
                                                            </HStack>
                                                            <Flex alignItems='end' mt='2'>
                                                                <Heading size='md' className="Title" color='#002EFF'>
                                                                    $
                                                                </Heading>
                                                                <Heading className="Title" color="#002EFF" lineHeight='1'>
                                                                    {formatNumber(equipos.equipo_precio_oferta)}
                                                                </Heading>
                                                            </Flex>
                                                            <Text className="Subtitle" fontSize={['sm','sm','md','md','md']}>
                                                                o {equipos.equipo_numero_cuotas} cuotas sin interés: <b>${formatNumber(equipos.equipo_valor_cuotas)}</b>
                                                            </Text>
                                                        </Box>
                                                    </Flex>
                                                    <Flex>
                                                        <Button onClick={() => editEquipo(equipos)} leftIcon={<TbEdit />} w='40%' bg='#002EFF' borderRadius='0px' borderBottomLeftRadius='12px' color='white'className='Title' border='2px solid #002EFF' _hover={{color: '#002EFF', bg: 'transparent'}}>
                                                            Editar
                                                        </Button>
                                                        <Button leftIcon={equipos.equipo_estado === 1 ? <BsToggleOn /> : <BsToggleOff />} w='60%' colorScheme={equipos.equipo_estado === 1 ? 'red' : 'green'} borderRadius='0px' borderBottomRightRadius='12px' color='white'className='Title' onClick={() => handleUpdateEquipo(equipos.equipo_id, equipos.equipo_estado)}>
                                                            {equipos.equipo_estado === 1 ? 'inactivar' : 'activar'} equipo
                                                        </Button>
                                                    </Flex>
                                                </Box>
                                            </SplideSlide>
                                        :
                                            <SplideSlide key={equipos.equipo_id}>
                                                <Box>
                                                    <Box _hover={{border:'1px solid #002EFF'}} borderRadius='12px' h={['269px','269px','530px','530px','530px']}>
                                                        <Image display={['block','block','none','none','none']} src={Movil} borderTopRadius='12px' h='100%' w='100%' />
                                                        <Image display={['none','none','flex','flex','flex']} src={`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${equipos.equipo_imagen}`} borderTopRadius='12px' h='100%' w='100%' />
                                                    </Box>
                                                    <Flex>
                                                        <Button onClick={() => editEquipo(equipos)} leftIcon={<TbEdit />} w='40%' bg='#002EFF' borderRadius='0px' borderBottomLeftRadius='12px' color='white'className='Title' border='2px solid #002EFF' _hover={{color: '#002EFF', bg: 'transparent'}}>
                                                            Editar
                                                        </Button>
                                                        <Button leftIcon={equipos.equipo_estado === 1 ? <BsToggleOn /> : <BsToggleOff />} w='60%' colorScheme={equipos.equipo_estado === 1 ? 'red' : 'green'} borderRadius='0px' borderBottomRightRadius='12px' color='white'className='Title'>
                                                            {equipos.equipo_estado === 1 ? 'inactivar' : 'activar'} equipo
                                                        </Button>
                                                    </Flex>
                                                </Box>
                                            </SplideSlide>
                                ))
                                :
                                    <>
                                        <SplideSlide>
                                            <Skeleton h='526px' />
                                        </SplideSlide>
                                        <SplideSlide>
                                            <Skeleton h='526px' />
                                        </SplideSlide>
                                        <SplideSlide>
                                            <Skeleton h='526px' />
                                        </SplideSlide>
                                        <SplideSlide>
                                            <Skeleton h='526px' />
                                        </SplideSlide>
                                        <SplideSlide>
                                            <Skeleton h='526px' />
                                        </SplideSlide>
                                    </>
                            }
                        </SplideTrack>

                        <div className="splide__arrows">
                            <button className="splide__arrow splide__arrow--prev arrow-next" type='button' >
                                <IconArrowRight size='5px' />
                            </button>
                            <button className="splide__arrow splide__arrow--next arrow-next" type='button' aria-label="Next slide" aria-controls="splide02-track">
                                <IconArrowRight size='5px' />
                            </button>
                        </div>
                    </Splide>
                </Box>
            </Box>
            
            {/* Modal create equipo */}
            <Modal isOpen={isOpen} onClose={onClose} size='5xl'>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader className='Title' textAlign='center' fontSize='2xl'>{typeAction} EQUIPO</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validationSchema={EquipoSchema}     
                            onSubmit={(values) => handleAddEquipo(values)}         
                        >
                            <Form>
                                <SimpleGrid columns={[1,1,2,2,2]} spacing='5'>
                                    <Box h='100%'>
                                        <Box my='5'>
                                            <Text className='Title'>NOTA</Text>
                                            <Text className='Subtitle' fontSize='sm'>
                                                La imagen del equipo se debe se subir con las siguientes especificaciones: <br /> <b>Ancho:</b> {principal ? '608px' : '100/200px'} - <b>Largo:</b> {principal ? '1008px' : '200/220px'} - <b>Formato:</b> WEBP
                                            </Text>
                                        </Box>
                                        <SwitchControl className='Subtitle' onChange={(e) => handleUpdateTypeOffer(e.target.value)} name="equipo_principal" label="Principal" />
                                        <SimpleGrid columns={[1,1,2,2,2]} mt='5' spacing='4'>
                                            {!principal && <InputControl className='Subtitle' onChange={(e) => setNombreEquipo(e.target.value)} name='equipo_nombre' label={principal ? 'Titulo' : 'Nombre del equipo'} />}
                                            {!principal && <InputControl className='Subtitle' onChange={(e) => setReferenciaEquipo(e.target.value)} name='equipo_referencia' label='Referencia del equipo' />}
                                            {!principal && <InputControl className='Subtitle' onChange={(e) => setDescuento(e.target.value)} name='equipo_descuento' label='Descuento' />}
                                            {!principal && <InputControl className='Subtitle' onChange={(e) => setPrecioNormal(e.target.value)} name='equipo_precio_normal' label={principal ? 'Precio' : 'Precio Normal'} />}
                                            {!principal && <InputControl className='Subtitle' onChange={(e) => setPrecioOferta(e.target.value)} name='equipo_precio_oferta' label='Precio Oferta' />}
                                            {!principal && <InputControl className='Subtitle' onChange={(e) => setNumeroCuotas(e.target.value)} name='equipo_numero_cuotas' label='Número de cuotas' />}
                                            {!principal && <InputControl className='Subtitle' onChange={(e) => setValorCuotas(e.target.value)} name='equipo_valor_cuotas' label='Valor de cuotas' />}
                                            <InputControl className='Subtitle' inputProps={{type:'file', variant:'unstyled'}} onChange={(e) => handleChange(e)} name='equipo_imagen' label='Imagen' />
                                        </SimpleGrid>
                                    </Box>

                                    <Box>
                                        {
                                            principal
                                                ?
                                                    <>
                                                        <Box w='300px' h='526px' m='auto'>
                                                            {
                                                                localImage 
                                                                    ?
                                                                        <Image src={previewImage} position='absolute' fallbackSrc='https://via.placeholder.com/300x260' alt="Preview" w='300px' h='526px' />
                                                                    :
                                                                        previewImage && 
                                                                            <Image src={`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${previewImage}`} fallbackSrc='https://via.placeholder.com/200x260' alt="Preview" minW='100%' maxW='100%' />
                                                            }
                                                        </Box>
                                                    </>
                                                :
                                                    <Box border='1px solid #E9E9E9' borderRadius='12px' w='300px' h='526px' m='auto'>
                                                        <Flex bg='#F7F7F7' p='16px' justifyContent='center' alignItems='center' borderLeftRadius={['12px','12px','0px','0px','0px']} borderTopRadius={['0px','0px','12px','12px','12px']} position='relative'>
                                                            <Box position='absolute' top='2' right='2' left={[2,2,'auto','auto','auto']}>
                                                                <Icon5G size='35' />
                                                            </Box>
                                                            <Flex w={['110px','110px','272px','272px','272px']} h={['220px','220px','226px','226px','226px']} justifyContent='center' alignItems='center'>
                                                                {
                                                                    localImage 
                                                                        ?
                                                                            <Image src={previewImage} fallbackSrc='https://via.placeholder.com/200x220' alt="Preview" minW='100px' maxW='200px' maxH='220px' minH='200px' />
                                                                        :
                                                                            previewImage && 
                                                                                <Image src={`https://webserver.becallcolombia.com/backend_entel/public/imagenesEquipos/${previewImage}`} fallbackSrc='https://via.placeholder.com/200x220' alt="Preview" minW='100px' maxW='200px' maxH='220px' minH='200px' />
                                                                }
                                                            </Flex>
                                                        </Flex>
                                                        <Box px='3' py='4'>
                                                            <Text className="Title">
                                                                {nombreEquipo}
                                                            </Text>
                                                            <Text className="Subtitle" fontSize='lg' h='85px' noOfLines='2'>  
                                                                {referenciaEquipo}
                                                            </Text>
                                                            
                                                            <Button cursor='default' px='2' py='1' fontSize='15px' borderRadius='4px' _focusVisible={{}} _hover={{}} bg='#A0F3D9' className="Title" size='xs' _active={{}} h='auto'>
                                                                {descuento}% dcto.
                                                            </Button>
                                                            
                                                            <HStack spacing='1' mt='1'>
                                                                <Text color='#66686C' className="Subtitle" fontSize='sm' my='1'> 
                                                                    Precio normal:
                                                                </Text>
                                                                <Text className='Subtitle' as='s'>${formatNumber(precioNormal)}</Text>
                                                            </HStack>
                                                            <Flex alignItems='end' mt='2'>
                                                                <Heading size='md' className="Title" color='#002EFF'>
                                                                    $
                                                                </Heading>
                                                                <Heading className="Title" color="#002EFF" lineHeight='1'>
                                                                    {formatNumber(precioOferta)}
                                                                </Heading>
                                                            </Flex>
                                                            <Text className="Subtitle" fontSize={['sm','sm','md','md','md']}>
                                                                o {numeroCuotas} cuotas sin interés: <b>${formatNumber(valorCuotas)}</b>
                                                            </Text>
                                                        </Box>
                                                    </Box>
                                        }
                                    </Box>
                                </SimpleGrid>

                                <Flex justifyContent='center' mt='7'>
                                    <Button mr='5' onClick={onClose}>
                                        CANCELAR
                                    </Button>
                                    <Button bg='#002EFF' isLoading={updateButton} loadingText='Cargando...' border='2px solid #002EFF' type='submit' color='white' _hover={{bg:'transparent', color:'#002EFF'}}>
                                        CONFIRMAR
                                    </Button>
                                </Flex>
                            </Form>
                        </Formik>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default AdminEquipos